/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

root.initInviteWidget = function() {
  $('#invite-widget-form').find('textarea, input').focus(() => $('#invite-widget-form .message').hide());
  return initMoreInviteFields();
};

root.initInviteForm = function() {
  $('#invite-form a.email-to-link').click(function() {
    $('#invite-form .invitation-link-tab a').click();
    return false;
  });
  return $('#invitation-community-select select').change(function() {
    const link_val = $(this).val();
    const link = $('#invitation-community-link');
    link.slideUp();
    window.setTimeout((() => link.val(link_val)), 400);
    return link.slideDown();
  });
};
root.initMoreInviteFields = () => $('#invite-widget-form .show-more-fields a').click(function() {
  $('#invite-widget-form .message').hide();
  const obj = $(this);
  obj.parent().hide();
  obj.parents('form').find('.more-fields').show();
  return false;
});

root.initCustomContentFields = () => $('#invitation #invitation_custom_content').change(function() {
  if ($(this).prop('checked')) {
    $('#invitation .custom-content-fields').show();
    $('#invitation .custom-content-fields textarea').prop('disabled', '');
    return $('#invitation .invitation_message').hide();
  } else {
    $('#invitation .custom-content-fields').hide();
    $('#invitation .custom-content-fields textarea').prop('disabled', 'disabled');
    return $('#invitation .invitation_message').show();
  }
});

const updateInviteListSummaryField = function(container, total, count) {
  const $container = $(container);
  $('.count', $container).text(count);
  return $('.percent', $container).text(((count * 100) / total).toFixed(1));
};

const updateInviteListSummary = function(result, $invite_list_id) {
  if (result) {
    const {
      total
    } = result;
    if (total > 0) {
      $invite_list_id.val(result._id);
      $('.total', $('#total-invite-list')).text(total);
      $('.total-count', $('#valid-invite-list-container')).text(result.parsed_emails_count);
      updateInviteListSummaryField('#invalid-email-list', total, result.invalid_emails_count);
      updateInviteListSummaryField('#duplicated-email-list', total, result.duplicated_emails_count);
      updateInviteListSummaryField('#joined-email-list', total, result.already_joined_emails_count);
      return updateInviteListSummaryField('#invited-email-list', total, result.already_invited_emails_count);
    }
  }
};

root.initEmailInviteForm = function() {
  $('#invitation_raw_emails').on('input propertychange paste keyup change', function() {
    const moreThan10 = $(this).val().split("@").length > 11;
    $('#new_invitation .button').prop('disabled', moreThan10);
    return $('#new_invitation .footnote').toggle(moreThan10);
  });
  return initInvitation();
};

root.initInviteList = function() {
  const $emailSourceRadios = $('input[name="invitation[email_source]"]');
  $emailSourceRadios.on('change', function() {
    const val = $(this).val();
    $('#use-email-list').toggleClass('hidden', val !== 'email_list');
    $('#use-raw-emails').toggleClass('hidden', val !== 'raw');
  });

  const $raw_emails = $('#invitation_raw_emails');
  const $upload_container = $('#invite-list-container');
  const $upload_button = $('#invite-list');
  const $summary_container = $('#invite-list-summary-container');
  const $cancel_upload_container = $('#cancel-invite-list-container');
  const $cancel_upload_button = $('#cancel-invite-list');
  const $invite_list_id = $('#invite-list-id');
  const $account_id = $('#account_id');

  $summary_container.hide();
  $cancel_upload_container.hide();
  $upload_button.prop('disabled', false);

  $cancel_upload_button.on('click', function(event) {
    event.preventDefault();
    $summary_container.hide();
    $cancel_upload_container.hide();
    $raw_emails.show();
    $upload_container.show();

    const invite_list_id = $invite_list_id.val();
    if (invite_list_id) {
      $invite_list_id.val('');
      $.ajax({
        type: 'DELETE',
        url: $cancel_upload_button.data('url') + '/' + invite_list_id,
        dataType: 'json'
      });
    }
  });

  $account_id.on('change', function() {
    const invite_list_id = $invite_list_id.val();
    const account_id = $account_id.val();
    if (invite_list_id && account_id) {
      $.ajax({
        type: 'PUT',
        url: $upload_button.data('url') + '/' + invite_list_id,
        dataType: 'json',
        data: { account_id },
        success(result) {
          updateInviteListSummary(result, $invite_list_id);
        }
      });
    }
  });

  if ($upload_button.length && typeof $upload_button.fileupload === 'function') {
    $upload_button.fileupload({
      type: 'POST',
      url: $upload_button.data('url'),
      dataType: 'json',
      formData(form) {
        return [{name: 'account_id', value: form[0].elements['invitation[account_id]'].value}];
      },
      add(event, data) {
        const types = /(\.|\/)(txt|csv)$/i;
        const file = data.files[0];
        if (types.test(file.type) || types.test(file.name)) { data.submit(); }
      },
      done(event, data) {
        updateInviteListSummary(data.result, $invite_list_id);

        $upload_container.hide();
        $raw_emails.hide();
        $summary_container.show();
        $cancel_upload_container.show();
      }
    });
  }
};

/*
$(function() {
  if ($('#invite-widget-form .more-fields').length) {
    initMoreInviteFields();
  }
  if ($('#invitation .custom-content-fields').length) {
    initCustomContentFields();
    $('#invitation #invitation_custom_content').trigger('change');
  }
  if ($('#email-invite-form').length) {
    return initEmailInviteForm();
  }
});

*/

function initInvitationsOnLoad() {
  if ($('#invite-widget-form .more-fields').length) {
    initMoreInviteFields();
  }
  if ($('#invitation .custom-content-fields').length) {
    initCustomContentFields();
    $('#invitation #invitation_custom_content').trigger('change');
  }
  if ($('#email-invite-form').length) {
    return initEmailInviteForm();
  }
  const $emailSourceRadios = $('input[name="invitation[email_source]"]');
  if ($emailSourceRadios.length) {
    $emailSourceRadios.on('change', function() {
      const val = $(this).val();
      $('#use-email-list').toggleClass('hidden', val !== 'email_list');
      $('#use-raw-emails').toggleClass('hidden', val !== 'raw');
    });
  }
}

$(initInvitationsOnLoad);
document.addEventListener('turbo:load', initInvitationsOnLoad);
